import { useState, useEffect } from 'react';
import axios from 'axios';

// City-specific Unsplash images for dynamic background
const cityImages = {
  // Major US Cities
  'wichita': 'https://images.unsplash.com/photo-1543858174-062e97c67af9?w=1920',
  'new york': 'https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?w=1920',
  'los angeles': 'https://images.unsplash.com/photo-1534190760961-74e8c1c5c3da?w=1920',
  'chicago': 'https://images.unsplash.com/photo-1494522855154-9297ac14b55f?w=1920',
  'houston': 'https://images.unsplash.com/photo-1531218150217-54595bc2b934?w=1920',
  'phoenix': 'https://images.unsplash.com/photo-1469401757102-8a6a5a7f3b36?w=1920',
  'philadelphia': 'https://images.unsplash.com/photo-1494522323175-b8f52e9a0e76?w=1920',
  'san antonio': 'https://images.unsplash.com/photo-1564758866789-81e8d49cd97c?w=1920',
  'san diego': 'https://images.unsplash.com/photo-1538970272646-f61fabb3a8a2?w=1920',
  'dallas': 'https://images.unsplash.com/photo-1545194445-dddb8f4487c6?w=1920',
  'san jose': 'https://images.unsplash.com/photo-1583001931096-959e9a1a6223?w=1920',
  'austin': 'https://images.unsplash.com/photo-1588993608635-5ca26ef93a11?w=1920',
  'jacksonville': 'https://images.unsplash.com/photo-1586299629982-d9e3f1d5ecef?w=1920',
  'san francisco': 'https://images.unsplash.com/photo-1449034446853-66c86144b0ad?w=1920',
  'columbus': 'https://images.unsplash.com/photo-1564758866789-81e8d49cd97c?w=1920',
  'fort worth': 'https://images.unsplash.com/photo-1545194445-dddb8f4487c6?w=1920',
  'indianapolis': 'https://images.unsplash.com/photo-1586299629982-d9e3f1d5ecef?w=1920',
  'charlotte': 'https://images.unsplash.com/photo-1583001931096-959e9a1a6223?w=1920',
  'seattle': 'https://images.unsplash.com/photo-1502175353174-a7a70e73b362?w=1920',
  'denver': 'https://images.unsplash.com/photo-1519424187720-db6d0fc5a5d2?w=1920',
  'washington': 'https://images.unsplash.com/photo-1501466044931-62695aada8e9?w=1920',
  'boston': 'https://images.unsplash.com/photo-1501785888041-af3ef285b470?w=1920',
  'el paso': 'https://images.unsplash.com/photo-1469401757102-8a6a5a7f3b36?w=1920',
  'detroit': 'https://images.unsplash.com/photo-1568515045052-f9a854d70bfd?w=1920',
  'nashville': 'https://images.unsplash.com/photo-1550099263-b8e09e2c2be7?w=1920',
  'memphis': 'https://images.unsplash.com/photo-1578496480157-697fc14b0f95?w=1920',
  'portland': 'https://images.unsplash.com/photo-1535139262971-c51845709a48?w=1920',
  'oklahoma': 'https://images.unsplash.com/photo-1586797011074-6d2e6f4cdf1c?w=1920',
  'las vegas': 'https://images.unsplash.com/photo-1534786514-c0ce64e6e37f?w=1920',
  'louisville': 'https://images.unsplash.com/photo-1564758866789-81e8d49cd97c?w=1920',
  'baltimore': 'https://images.unsplash.com/photo-1588093413519-c96c98dcf696?w=1920',
  'milwaukee': 'https://images.unsplash.com/photo-1578496480157-697fc14b0f95?w=1920',
  'albuquerque': 'https://images.unsplash.com/photo-1469401757102-8a6a5a7f3b36?w=1920',
  'tucson': 'https://images.unsplash.com/photo-1469401757102-8a6a5a7f3b36?w=1920',
  'fresno': 'https://images.unsplash.com/photo-1534190760961-74e8c1c5c3da?w=1920',
  'sacramento': 'https://images.unsplash.com/photo-1534190760961-74e8c1c5c3da?w=1920',
  'mesa': 'https://images.unsplash.com/photo-1469401757102-8a6a5a7f3b36?w=1920',
  'atlanta': 'https://images.unsplash.com/photo-1575917649705-5b59aaa12e6b?w=1920',
  'kansas city': 'https://images.unsplash.com/photo-1543858174-062e97c67af9?w=1920',
  'colorado springs': 'https://images.unsplash.com/photo-1519424187720-db6d0fc5a5d2?w=1920',
  'miami': 'https://images.unsplash.com/photo-1514214246283-d427a95c5d2f?w=1920',
  'raleigh': 'https://images.unsplash.com/photo-1583001931096-959e9a1a6223?w=1920',
  'omaha': 'https://images.unsplash.com/photo-1543858174-062e97c67af9?w=1920',
  'minneapolis': 'https://images.unsplash.com/photo-1585051243424-2c2f3e9c2f32?w=1920',
  'virginia beach': 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1920',
  'arlington': 'https://images.unsplash.com/photo-1545194445-dddb8f4487c6?w=1920',
  'new orleans': 'https://images.unsplash.com/photo-1547050605-2f268cd5d09e?w=1920',
  'honolulu': 'https://images.unsplash.com/photo-1542259009477-d625272157b7?w=1920',
  'bakersfield': 'https://images.unsplash.com/photo-1534190760961-74e8c1c5c3da?w=1920',
  'tampa': 'https://images.unsplash.com/photo-1514214246283-d427a95c5d2f?w=1920',
  'tulsa': 'https://images.unsplash.com/photo-1586797011074-6d2e6f4cdf1c?w=1920',
  'anaheim': 'https://images.unsplash.com/photo-1534190760961-74e8c1c5c3da?w=1920',
  'aurora': 'https://images.unsplash.com/photo-1519424187720-db6d0fc5a5d2?w=1920',
  'santa ana': 'https://images.unsplash.com/photo-1534190760961-74e8c1c5c3da?w=1920',
  'st louis': 'https://images.unsplash.com/photo-1564758866789-81e8d49cd97c?w=1920',
  'pittsburgh': 'https://images.unsplash.com/photo-1556909114-44e3e70034e2?w=1920',
  'riverside': 'https://images.unsplash.com/photo-1534190760961-74e8c1c5c3da?w=1920',
  'corpus christi': 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1920',
  'lexington': 'https://images.unsplash.com/photo-1564758866789-81e8d49cd97c?w=1920',
  'anchorage': 'https://images.unsplash.com/photo-1519424187720-db6d0fc5a5d2?w=1920',
  'stockton': 'https://images.unsplash.com/photo-1534190760961-74e8c1c5c3da?w=1920',
  'cincinnati': 'https://images.unsplash.com/photo-1564758866789-81e8d49cd97c?w=1920',
  'st paul': 'https://images.unsplash.com/photo-1585051243424-2c2f3e9c2f32?w=1920',
  'newark': 'https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?w=1920',
  'greensboro': 'https://images.unsplash.com/photo-1583001931096-959e9a1a6223?w=1920',
  'plano': 'https://images.unsplash.com/photo-1545194445-dddb8f4487c6?w=1920',
  'henderson': 'https://images.unsplash.com/photo-1534786514-c0ce64e6e37f?w=1920',
  'lincoln': 'https://images.unsplash.com/photo-1543858174-062e97c67af9?w=1920',
  'buffalo': 'https://images.unsplash.com/photo-1564758866789-81e8d49cd97c?w=1920',
  'chula vista': 'https://images.unsplash.com/photo-1538970272646-f61fabb3a8a2?w=1920',
  'jersey city': 'https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?w=1920',
  'chandler': 'https://images.unsplash.com/photo-1469401757102-8a6a5a7f3b36?w=1920',
  'gilbert': 'https://images.unsplash.com/photo-1469401757102-8a6a5a7f3b36?w=1920',
  'madison': 'https://images.unsplash.com/photo-1578496480157-697fc14b0f95?w=1920',
  'reno': 'https://images.unsplash.com/photo-1534786514-c0ce64e6e37f?w=1920',
  'lubbock': 'https://images.unsplash.com/photo-1545194445-dddb8f4487c6?w=1920',
  'north las vegas': 'https://images.unsplash.com/photo-1534786514-c0ce64e6e37f?w=1920',
  'scottsdale': 'https://images.unsplash.com/photo-1469401757102-8a6a5a7f3b36?w=1920',
  'glendale': 'https://images.unsplash.com/photo-1469401757102-8a6a5a7f3b36?w=1920',
  'irving': 'https://images.unsplash.com/photo-1545194445-dddb8f4487c6?w=1920',
  'chesapeake': 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1920',
  'orlando': 'https://images.unsplash.com/photo-1514214246283-d427a95c5d2f?w=1920',
  'fremont': 'https://images.unsplash.com/photo-1449034446853-66c86144b0ad?w=1920',
  'laredo': 'https://images.unsplash.com/photo-1545194445-dddb8f4487c6?w=1920',
  'garland': 'https://images.unsplash.com/photo-1545194445-dddb8f4487c6?w=1920',
  'baton rouge': 'https://images.unsplash.com/photo-1547050605-2f268cd5d09e?w=1920',
  'norfolk': 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1920',
  'winston-salem': 'https://images.unsplash.com/photo-1583001931096-959e9a1a6223?w=1920',
  // Default for unknown cities
  'default': 'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=1920'
};

// Get city name from coordinates using reverse geocoding
const getCityFromCoords = async (lat, lng) => {
  try {
    const response = await axios.get(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`,
      {
        headers: {
          'User-Agent': 'vgoride-App/1.0'
        }
      }
    );
    
    const address = response.data.address;
    // Try to get city, then town, then county
    return address.city || address.town || address.county || address.state || 'default';
  } catch (error) {
    console.error('Failed to reverse geocode:', error);
    return 'default';
  }
};

// Get background image for a city
const getBackgroundImage = (cityName) => {
  const normalizedCity = cityName.toLowerCase();
  
  // Try exact match first
  if (cityImages[normalizedCity]) {
    return cityImages[normalizedCity];
  }
  
  // Try partial match
  for (const [city, url] of Object.entries(cityImages)) {
    if (normalizedCity.includes(city) || city.includes(normalizedCity)) {
      return url;
    }
  }
  
  return cityImages.default;
};

export function useLocationBackground() {
  const [backgroundImage, setBackgroundImage] = useState(cityImages.wichita); // Default to Wichita
  const [cityName, setCityName] = useState('Wichita');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const detectLocation = async () => {
      if (!navigator.geolocation) {
        setLoading(false);
        return;
      }

      try {
        const position = await new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject, {
            timeout: 10000,
            maximumAge: 300000 // Cache for 5 minutes
          });
        });

        const { latitude, longitude } = position.coords;
        const city = await getCityFromCoords(latitude, longitude);
        const image = getBackgroundImage(city);
        
        setCityName(city.charAt(0).toUpperCase() + city.slice(1));
        setBackgroundImage(image);
      } catch (error) {
        console.error('Failed to detect location:', error);
        // Keep default (Wichita)
      } finally {
        setLoading(false);
      }
    };

    detectLocation();
  }, []);

  return { backgroundImage, cityName, loading };
}

export default function LocationBackground({ children, className = '' }) {
  const { backgroundImage } = useLocationBackground();

  return (
    <div className={`relative min-h-screen ${className}`}>
      {/* Background Image */}
      <div 
        className="fixed inset-0 z-0"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-black/70" />
      </div>
      
      {/* Content */}
      <div className="relative z-10">
        {children}
      </div>
    </div>
  );
}
